import React from "react"

export const EnvironmentContext = React.createContext()
export const StateMachineContext = React.createContext()
export const FirebaseContext = React.createContext()
export const AuthenticationContext = React.createContext()
export { default as UserContext } from "./UserContext"
